body.on('change', '.LV_zone_group', function () {
    LVPhase2();
    LVPhase3();
});

body.on('change', '.LV_price_radio', function () {
    LVPhase3();
});

function LVPhase2() {
    let zoneGroupLV = parseInt($('.LV_zone_group:checked').val());
    let LVPhase2Wrapper = $('#LV_phase_2');

    LVPhase2Wrapper.addClass('d-none');

    // Hide all prices where data-group !== zoneGroupLV and unselect all radios
    LVPhase2Wrapper.find('.LV_price_radio_wrapper').each(function () {
        $(this).addClass('d-none');

        let radio = $(this).find('input[type="radio"]');
        $(radio).prop('checked', false);

        let priceZoneGroup = parseInt($(this).data('group'));

        if (priceZoneGroup === zoneGroupLV) {
            $(this).removeClass('d-none');
        }
    });

    LVPhase2Wrapper.removeClass('d-none');
}

function LVPhase3() {
    let LVPhase3Wrapper = $('#LV_phase_3');
    let zoneGroupLV = parseInt($('.LV_zone_group:checked').val());
    let priceTableLV = parseInt($('.LV_price_radio:checked').val());

    LVPhase3Wrapper.addClass('d-none');

    if (!zoneGroupLV || !priceTableLV) {
        return;
    }

    let partner = parseInt($('#partner').val());
    let zoneSelect = $('#zone_lv');
    let url = zoneSelect.data('url');
    let method = zoneSelect.data('method');

    $.ajax({
        url: url,
        type: method,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        data: {
            zone_group_lv_id: zoneGroupLV,
            partner_id: partner,
        },
        success: function (response) {
            if (response.status === 'success') {
                LVPhase3Wrapper.removeClass('d-none');
                zoneSelect.html(
                    '<option value="">Escolha uma zona</option>'
                );
                console.log(response.zonesLV);
                $.each(response.zonesLV, function (i, v) {
                    zoneSelect.append(
                        '<option value="' + v.id + '">' + v.label + '</option>'
                    );
                });


            } else {
                console.error('Error fetching zones');
            }
        },
        error: function (error) {
            console.error('Error fetching zones', error);
        }
    });
}
